import axios from './axiosConfig';
//import { createBrowserHistory } from "history";
//const API_URL = "https://api.test.raborisk.ai";
const API_URL = process.env.NODE_ENV === 'production'

  ? "https://api.test.raborisk.ai"
  : "http://localhost:3000";

const PYTHON_API_URL = "https://api.ai.raborisk.ai"


//const history = createBrowserHistory();

export const getUsersList = () => (dispatch) => {
    return axios.get(API_URL + "/api/risk/get_users_list")
        .then(({ data }) => {
            dispatch({ type: "RISK_USERS_LIST", users: data });
        })
        .catch((err) => console.error("Error fetching users list:", err));
};

export const getLevels = (company_id = null) => {
    //console.log("calling get Elvels")
    return (dispatch) => {

        const url = company_id
            ? `${API_URL}/api/risk/get_risk_levels?company_id=${company_id}`
            : `${API_URL}/api/risk/get_risk_levels`;

        axios.get(url)
            .then(({ data }) => {
                //console.log(data);
                dispatch({ type: "LEVELS", levels: data });
            });
    };
};

export const editImpact = (
    impact_id,
    operational,
    financial_low,
    financial_high,
    reputational,
    compliance,
    strategic,
    company_id = null
) => {
    return (dispatch) => {

        const payload = {
            impact_id,
            operational,
            financial_low,
            financial_high,
            reputational,
            compliance,
            strategic
        };

        if (company_id) {
            payload.company_id = company_id;
        }

        axios
            .post(API_URL + "/api/risk/edit_impact", payload)
            .then(({ data }) => {
                dispatch({ type: "LEVELS", levels: data });
            })
            .catch((error) => {
                console.error("Error editing impact:", error);
            });
    };
};

export const editProbability = (
    probability_id,
    controls,
    frequency,
    company_id = null
) => {
    return (dispatch) => {

        const payload = {
            probability_id,
            controls,
            frequency
        };
        if (company_id) {
            payload.company_id = company_id;
        }

        axios
            .post(API_URL + "/api/risk/edit_probability", payload)
            .then(({ data }) => {
                dispatch({ type: "LEVELS", levels: data });
            })
            .catch((error) => {
                console.error("Error editing probability:", error);
            });
    };
};

export const getIncidents_Report = (department_id) => {
    return (dispatch) => {
        axios.get(API_URL + "/api/risk/get_incidents_report?department_id=" + department_id)
            .then(({ data }) => {
                dispatch({ type: "INCIDENTS_REPORT", risk_incidents: data });
            });
    };
};

export const getIncidents_Report_ByCompliance = (compliance_id) => {
  return (dispatch) => {
    axios
      .get(API_URL + "/api/risk/get_incidents_report?compliance_id=" + compliance_id)
      .then(({ data }) => {
        dispatch({ type: "INCIDENTS_REPORT", risk_incidents: data });
      });
  };
};

export const getDepartmentIncidents = (department_id) => {
    return (dispatch) => {
        axios.get(API_URL + "/api/risk/get_department_incidents?department_id=" + department_id)
            .then(({ data }) => {
                dispatch({ type: "DEPARTMENT_INCIDENTS", department_incidents: data });
            });
    };
};

export const getComplianceIncidents = (compliance_id) => {
    return (dispatch) => {
        axios.get(API_URL + "/api/risk/get_compliance_incidents?compliance_id=" + compliance_id)
            .then(({ data }) => {
                
                dispatch({ type: "DEPARTMENT_INCIDENTS", department_incidents: data });
            });
    };
};

export const getActions_Report = (department_id) => {

    // ////////console.log("sortByString:", sortByString);
    return (dispatch) => {
        axios.get(API_URL + "/api/risk/get_actions_report?department_id=" + department_id)
            .then(({ data }) => {
                ////console.log("Actions", data)
                dispatch({ type: "ACTIONS_REPORT", risk_actions: data.actions });
            });
    };
};

export const getActions_Report_ByCompliance = (compliance_id) => {
  return (dispatch) => {
    axios
      .get(API_URL + "/api/risk/get_actions_report?compliance_id=" + compliance_id)
      .then(({ data }) => {
        dispatch({ type: "ACTIONS_REPORT", risk_actions: data.actions });
      });
  };
};




export const getControls_Report = (department_id) => {
    const scopeKey = `dept:${department_id ?? 0}`;
    return (dispatch) => {
        dispatch({ type: "CONTROLS_REQUEST", scopeType: "dept", scopeId: department_id });
        return axios.get(`${API_URL}/api/risk/get_controls_report?department_id=${department_id}`)
            .then(({ data }) => {
                dispatch({ type: "CONTROLS_REPORT", risk_controls: data.controls, scopeKey });
            })
            .catch((error) => {
                console.error("Error fetching controls report:", error);
            });
    };
};


export const getControls_Report_ByCompliance = (compliance_id) => {
  const scopeKey = `comp:${compliance_id ?? 0}`;
  return (dispatch) => {
    dispatch({ type: "CONTROLS_REQUEST", scopeType: "comp", scopeId: compliance_id });
    return axios
      .get(`${API_URL}/api/risk/get_controls_report?compliance_id=${compliance_id}`)
      .then(({ data }) => {
        dispatch({ type: "CONTROLS_REPORT", risk_controls: data.controls, scopeKey });
      })
      .catch((error) => {
        console.error("Error fetching compliance controls report:", error);
      });
  };
};

export const getControls_Search = (department_id) => {
    const scopeKey = `dept:${department_id ?? 0}`;
    return (dispatch) => {
        dispatch({ type: "ALL_CONTROLS_REQUEST", department_id });
        return axios.get(`${API_URL}/api/risk/get_controls_search?department_id=${department_id}`)
            .then(({ data }) => {
                dispatch({ type: "CONTROLS_SEARCH", risk_controls: data.controls, visibleFindingCount: data.visibleFindingCount ?? 0, scopeKey });
            })
            .catch((error) => {
                console.error("Error fetching controls report:", error);
            });
    };
};

export const getComplianceControls_Report = (compliance_id) => {
    return (dispatch) => {
        return axios.get(`${API_URL}/api/risk/get_compliance_controls_report?compliance_id=${compliance_id}`)
            .then(({ data }) => {
                ////console.log("COMPLIANCE_CONTROLS_REPORT", data)
                dispatch({ type: "COMPLIANCE_CONTROLS_REPORT", compliance_controls: data.controls });
            })
            .catch((error) => {
                console.error("Error fetching controls report:", error);
            });
    };
};

export const getRisks_Report = (department_id) => {

    // ////////console.log("sortByString:", sortByString);
    return (dispatch) => {
        axios.get(API_URL + "/api/risk/get_risks_report?department_id=" + department_id)
            .then(({ data }) => {
                dispatch({ type: "RISKS_REPORT", risks_report: data.risks });
            });
    };
};

export const getRisks_Report_ByCompliance = (compliance_id) => {
  return (dispatch) => {
    axios
      .get(API_URL + "/api/risk/get_risks_report?compliance_id=" + compliance_id)
      .then(({ data }) => {
        dispatch({ type: "RISKS_REPORT", risks_report: data.risks });
      });
  };
};


export const getAllRisks_Report = () => {

    // ////////console.log("sortByString:", sortByString);
    return (dispatch) => {
        axios.get(API_URL + "/api/risk/get_allrisks_report")
            .then(({ data }) => {
                dispatch({ type: "ALL_RISKS_REPORT", risks_report: data.risks });
            });
    };
};


export const deleteAction = (risk_id, action_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/delete_action", { risk_id: risk_id, action_id: action_id })
            .then(({ data }) => {
                dispatch({ type: "RISK", risk: data });
            });
    };
};


export const addActionComment = (comment, action_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/add_action_comment", { comment: comment, action_id: action_id })
            .then(({ data }) => {
                //dispatch({ type: "ADD_COMMENT", comment: data.comment });
                dispatch({ type: "ACTION_DETAILS", action_details: data.data, comments: data.comments });
            });
    };
};

export const addAttachmentAction = (actionId, file) => {
  return (dispatch) => {
    const formData = new FormData();

    formData.append("action_id", actionId);
    formData.append("file", file); 

    return axios
      .post(`${API_URL}/api/risk/add_attachment_action`, formData)
      .then((response) => {
        dispatch({
          type: "ADD_ATTACHMENT_ACTION",
          payload: response.data,
        });

        return response.data;
      });
  };
};


export const getActionDetails = (risk_id, action_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/get_action_details", { risk_id: risk_id, action: action_id })
            .then(({ data }) => {
                //////////console.log(data);
                dispatch({ type: "ACTION_DETAILS", action_details: data.data, comments: data.comments, attachments: data.attachments });
            });
    };
};






export const addControlComment = (comment, control_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/add_control_comment", { comment: comment, control_id: control_id })
            .then(({ data }) => {
                //dispatch({ type: "ADD_COMMENT", comment: data.comment });
                dispatch({ type: "CONTROL_DETAILS", control_details: data.data, comments: data.comments });
            });
    };
};


export const addFindingComment = (comment, finding_id) => {
    return (dispatch) => {
        return axios.post(API_URL + "/api/risk/add_finding_comment", {
            comment: comment,
            finding_id: finding_id
        })
        .then(({ data }) => {
            dispatch({
                type: "FINDING_DETAILS",
                finding_details: data.data,
                comments: data.comments
            });
            return data; // optional but useful
        });
    };
};

export const addAttachment = (risk_id, control_id, file) => {
    return (dispatch) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("risk_id", risk_id);
        formData.append("control_id", control_id);

        axios
            .post(API_URL + "/api/risk/add_attachment", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then(({ data }) => {
                // Dispatch ADD_ATTACHMENT with the newly added attachment
                const newAttachment = {
                    attachment_id: data.attachment_id,
                    file_url: data.file_url,
                    attachment_name: data.attachment_name,
                };

                dispatch({ type: "ADD_ATTACHMENT", attachment: newAttachment });
            })
            .catch((error) => {
                console.error("Error uploading file:", error);
            });
    };
};

export const getControlDetails = (control_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/get_control_details", { control_id })
            .then(({ data }) => {
                dispatch({
                    type: "CONTROL_DETAILS",
                    control_details: {
                        ...data.data,
                        attachments: data.attachments,
                        Checklist: data.checklist || [],
                        relatedRisks: data.relatedRisks || [],
                        owners: data.owners || [],
                        tests: data.tests || [],
                    },
                    comments: data.comments || [],
                });
            })
            .catch((error) => {
                console.error("Error fetching control details:", error);
            });
    };
};

export const addControlTest = (control_id, testData) => (dispatch) => {
    return axios.post(API_URL + "/api/risk/add_control_test", { control_id, ...testData })
        .then(({ data }) => {
            dispatch({ type: "CONTROL_TESTS_REPLACE", tests: data.tests });
            return data;
        })
        .catch((err) => console.error("Error in addControlTest:", err));
};

export const deleteControlTest = (test_id, control_id) => (dispatch) => {
    return axios.post(API_URL + "/api/risk/delete_control_test", { test_id, control_id })
        .then(({ data }) => {
            dispatch({ type: "CONTROL_TESTS_REPLACE", tests: data.tests });
            return data;
        })
        .catch((err) => console.error("Error in deleteControlTest:", err));
};


export const getControlLogs = (control_id) => {
    return (dispatch) => {
        return axios.post(API_URL + "/api/risk/get_control_logs", { control_id })
            .then(({ data }) => {
                dispatch({ type: "CONTROL_LOGS", logs: data.logs || [] });
                return data.logs || [];
            })
            .catch((error) => {
                console.error("Error fetching control logs:", error);
                return [];
            });
    };
};

export const deleteFinding = (finding_id) => {
  return (dispatch) => {
    return axios
      .post(`${API_URL}/api/risk/delete_finding`, { finding_id })
      .then(({ data }) => {
        if (data?.success) {
          
          return true;
        }
        throw new Error("Delete failed");
      })
      .catch((err) => {
        console.error("Error in deleteFinding:", err);
        throw err;
      });
  };
};

export const getFinding = (finding_id) => {
    ////console.log("Getting finding wiht id ", finding_id)
    return (dispatch) => {
        return axios
            .post(`${API_URL}/api/risk/get_finding`, { finding_id })
            .then(({ data }) => {
                if (data?.success && data?.finding) {
                    //console.log("Data ", data)
                    dispatch({ type: "FINDING_DETAILS_SET", payload: data.finding, comments: data.comments });
                    return data.finding;
                }
                throw new Error("API response missing finding");
            })
            .catch((err) => {
                console.error("Error in getFinding:", err);
                throw err;
            });
    };
};




export const deleteAttachment = (controlId, attachmentId) => {
    return (dispatch) => {
        return axios
            .delete(`${API_URL}/api/risk/delete_attachment`, {
                data: { control_id: controlId, attachment_id: attachmentId },
            })
            .then((response) => {
                ////////console.log("Attachment deleted successfully:", response.data);
                dispatch({ type: "DELETE_ATTACHMENT", attachment_id: attachmentId });
            })
            .catch((error) => {
                console.error("Error deleting attachment:", error);
                throw error;
            });
    };
};

export const deleteAttachmentAction = (actionId, attachmentId) => {
  return (dispatch) => {
    return axios
      .delete(`${API_URL}/api/risk/delete_attachment_action`, {
        data: { action_id: actionId, attachment_id: attachmentId },
      })
      .then((response) => {
        dispatch({
          type: "DELETE_ATTACHMENT_ACTION",
          attachment_id: attachmentId,
          action_id: actionId,
        });

        return response.data;
      })
      .catch((error) => {
        console.error("Error deleting action attachment:", error);
        throw error;
      });
  };
};
export const resetChangedPageSize = () => {
    return (dispatch) => {
        dispatch({ type: "RESET_CHANGED_PAGE_SIZE" });
    };
};

export const resetAllTableDefinitions = () => {
    return (dispatch) => {
        dispatch({ type: "RESETALLTABLEDEFINITIONS" });
    };
};

export const resetPreliminaryRisk = () => {
    return (dispatch) => {
        dispatch({ type: "RESET_PRELIMINARY_RISK" });
    };
};

export const createPreliminaryRisk = () => {
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/create_preliminary_risk")
            .then(({ data }) => {
                dispatch({ type: "CREATE_PRELIMINARY_RISK", preliminary_risk: data.id });
            });
    };
};

export const resetGotoRiskDashboard = () => {
    return (dispatch) => {
        dispatch({ type: "RESET_GOTO_RISK_DASHBOARD" });
    };
};

export const resetGotoBowtie = () => {
    return (dispatch) => {
        dispatch({ type: "RESET_GOTO_BOWTIE" });
    };
};

export const gotoRiskDashboard = (risk_id) => {
    ////console.log("Goin to stats for ", risk_id)
    return (dispatch) => {
        dispatch({ type: "GOTO_RISK_DASHBOARD", risk_id: risk_id });
    };
};

export const gotoBowtie = (risk_id) => {
    return (dispatch) => {
        dispatch({ type: "GOTO_BOWTIE", risk_id: risk_id });
    };
};


export const getBowtie = (risk_id) => {
  return (dispatch) => {
    return axios.get(API_URL + "/api/risk/get_bowtie/" + risk_id)
      .then(({ data }) => {
        ////console.log("Getting Bowtie ", data);
        dispatch({ type: "BOWTIE", bowtie: data });
        return data; // important
      });
  };
};


export const createBowtie = (risk_id) => {
  return (dispatch) => {
    return axios.post(API_URL + "/api/risk/create_bowtie/" + risk_id)
      .then(({ data }) => {
        ////console.log("Creating Bowtie ", data);
        dispatch({ type: "BOWTIE", bowtie: data });
        return data; // important
      });
  };
}

const serializeBowtie = (bowtie, formState) => ({
  bowtie_id: bowtie?.bowtie_id ?? null,
  risk_id: bowtie?.risk_id ?? null,
  threats: formState.BowtieThreats ?? [],
  threatControls: formState.ThreatCtrlByOwner ?? {},
  consequences: formState.BowtieConsequences ?? [],
  consequenceControls: formState.ConsequenceCtrlByOwner ?? {},
});

export const saveBowtie = (risk_id, bowtie, formState) => {
    ////console.log("formState ", formState)
    return async (dispatch) => {
        const payload = serializeBowtie(bowtie, formState);

        // choose an endpoint name that matches your style:
        // using /api/risk/save_bowtie/:risk_id to mirror create_bowtie
        const url = `${API_URL}/api/risk/save_bowtie/${risk_id}`;

        // optional: optimistic flag in state
        ////console.log("payload ", payload)
        try {
            const { data } = await axios.post(url, payload);
            // keep store in sync with what backend returns (ids/order may change)
            dispatch({ type: "BOWTIE_CLOSE" });
            return data; // allow caller to .then(...)
        } catch (err) {
            console.error("saveBowtie error:", err);
            dispatch({ type: "BOWTIE_SAVING", saving: false, error: err?.message });
            throw err;
        }
    };
};

export const resetSortedTriggered = () => {
    return (dispatch) => {
        dispatch({ type: "RESET_SORTED_TRIGGERED" });
    };
};

export const setSortByRedux = (sortBy) => {
    //////console.log("SortBy:", sortBy)
    return (dispatch) => {
        dispatch({ type: "SET_SORT_BY", sortBy: sortBy });
    };
};

export const setPageSizeRedux = (pageSize) => {
    return (dispatch) => {
        dispatch({ type: "SET_PAGE_SIZE", pageSize: pageSize });
    };
};

export const setCurrentPageRedux = (currentPage) => {
    return (dispatch) => {
        dispatch({ type: "SET_CURRENT_PAGE", currentPage: currentPage });
    };
};

export const deleteRisk = (
    risk_id,
    currentPage,
    pageSize,
    sortBy,
    department_id,
    compliance_id,
    get_all_after_delete,
) => {
    let sortByString = sortBy ? (sortBy?.length > 0 ? JSON.stringify(sortBy[0]) : null) : null;
    return (dispatch) => {
        return axios
            .post(API_URL + "/api/risk/delete_risk", {
                risk_id: risk_id,
                currentPage: currentPage,
                pageSize: pageSize,
                sortBy: sortByString,
                department_id: department_id,
                compliance_id: compliance_id,
                get_all_after_delete: get_all_after_delete,
            })
            .then(({ data }) => {
                dispatch({ type: "RISK_DELETED", risk_id });

                return data;
            })
            .catch((error) => {
                console.error("Error deleting risk:", error);
                dispatch({ type: "ERROR_DELETING_RISK" });
                throw error;
            });
    };
};

export const deleteControl = (risk_id, control_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/delete_control", { risk_id: risk_id, control_id: control_id })
            .then(({ data }) => {
                dispatch({ type: "RISK", risk: data });
            });
    };
};

export const aiControlDrop = (risk_id, control_data) => {
    return (dispatch) => {
        return axios
            .post(API_URL + "/api/risk/ai_control_drop", { risk_id, control_data })
            .then(({ data }) => {
                ////////console.log("API Response: ", data); // Log the entire response to confirm data structure
                if (data.success) {
                    ////////console.log("AI control dropped and added:", data.newControl);
                    // Dispatch action with success
                    dispatch({
                        type: "RISK",
                        newControl: data.newControl,
                        risk: data.risk,
                    });
                } else {
                    console.error("AI control drop failed:", data.message);
                    dispatch({
                        type: "AI_CONTROL_DROP_FAILURE",
                        message: data.message,
                    });
                    throw new Error(data.message); // Propagate the error
                }
            })
            .catch((err) => {
                console.error("Error in AI control drop:", err);
                dispatch({
                    type: "AI_CONTROL_DROP_FAILURE",
                    message: err.message || "Unexpected error",
                });
                throw err; // Propagate error to the calling code
            });
    };
};



export const aiRiskDrop = (risk_data, department_id) => {
    return (dispatch) => {
        return axios
            .post(API_URL + "/api/risk/ai_risk_drop", {risk_data, department_id })
            .then(({ data }) => {
                ////////console.log("API Response: ", data); // Log the entire response to confirm data structure
                if (data.success) {
                    ////////console.log("AI control dropped and added:", data.newControl);
                    // Dispatch action with success
                    ////console.log("Risk Retunred", data)
                    dispatch({
                        type: "RISKS",
                        risks: data.risks,
                    });
                    return data;
                } else {
                    console.error("AI Risk drop failed:", data.message);
                    dispatch({
                        type: "AI_CONTROL_DROP_FAILURE",
                        message: data.message,
                    });
                    throw new Error(data.message); // Propagate the error
                }
            })
            .catch((err) => {
                console.error("Error in AI control drop:", err);
                dispatch({
                    type: "AI_CONTROL_DROP_FAILURE",
                    message: err.message || "Unexpected error",
                });
                throw err; // Propagate error to the calling code
            });
    };
};

export const editAction = (risk_id, action_id, action) => async (dispatch) => {
    const res = await axios.post(
        `${API_URL}/api/risk/edit_action`,
        { risk_id, action_id, action }
    );
    const data = res.data;
    dispatch({ type: "ACTION_DETAILS", action_details: data.data, comments: data.comments });
    return data; // <-- caller can await this
};


// actions/riskActions.js
export const editActionProgressLabel = (action_id, stage) => async (dispatch) => {
  const res = await axios.post(`${API_URL}/api/risk/progress`, { action_id, stage });
  return res.data; // no dispatch here; rely on your getDepartmentsAction* refetch
};

export const editControl = (risk_id, control_id, control) => {
    return (dispatch) => {
        return axios.post(API_URL + "/api/risk/edit_control", { risk_id, control_id, control })
            .then(({ data }) => {
                dispatch({
                    type: "CONTROL_DETAILS",
                    control_details: {
                        ...data.data,
                        attachments: data.data?.attachments || [],
                        Checklist: data.checklist || [],
                        relatedRisks: data.data?.relatedRisks || [],
                        owners: data.owners || [],
                    },
                    comments: data.comments || [],
                });
                return data;
            })
            .catch((error) => {
                console.error("Error in editControl:", error);
                throw error;
            });
    };
};

export const assignControlToRisk = (control_id, risk_id) => {
  return (dispatch) => {
    return axios
      .post(API_URL + "/api/risk/assign-control-risk", { control_id, risk_id })
      .then(({ data }) => {
        // data: { success: true, control_id, risk_ids }
        // optional: dispatch something if you want to update UI state
        // dispatch({ type: "CONTROL_RISK_ASSIGNED", payload: data });

        return data; 
      })
      .catch((error) => {
        console.error("Error in assignControlToRisk:", error);
        console.error("Response Data:", error.response?.data);
        throw error;
      });
  };
};

export const unlinkControlFromRisk = (risk_id, control_id) => {
    return (dispatch) => {
        return axios
            .post(API_URL + "/api/risk/unlink_control_from_risk", { risk_id, control_id })
            .then(({ data }) => {
                if (data?.risk) {
                    dispatch({ type: "RISK", risk: data.risk });
                } else if (data) {
                    dispatch({ type: "RISK", risk: data });
                }
                return data;
            })
            .catch((error) => {
                console.error("Error in unlinkControlFromRisk:", error);
                throw error;
            });
    };
};

export const searchControlsForLink = ({
    departmentId = null,
    complianceId = null,
    q = '',
    page = 1,
    pageSize = 20,
    excludeRiskId = null,
}) => async () => {
    const params = { q, page, pageSize };
    if (complianceId) params.compliance_id = complianceId;
    else if (departmentId) params.department_id = departmentId;
    if (excludeRiskId) params.exclude_risk_id = excludeRiskId;

    const { data } = await axios.get(`${API_URL}/api/risk/search_controls_for_link`, { params });
    return data;
};

export const updateFinding = (form, finding_id) => {
    //console.log(form)
  return (dispatch) => {
    return axios
      .post(`${API_URL}/api/risk/update_finding`, { finding_id, data: form })
      .then(({ data }) => {
        if (data?.success && data?.finding) {
          // 1) Update "finding_details" if you store it
         

          return data.finding;
        }
        throw new Error("API response missing finding");
      })
      .catch((err) => {
        console.error("Error in updateFinding:", err);
        throw err;
      });
  };
};


export const editRisk = (risk_id, risk) => {
    //console.log("risk_edited", risk)
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/edit_risk", { risk_id: risk_id, risk: risk })
            .then(({ data }) => {
                ////console.log("Risk Data Returned nORMAL:", data)
                //dispatch({ type: "RISK", risk: data });
                return data;
            });
    };
};

export const editRiskSave = (risk_id, risk) => {
    ////console.log("risk_edited", risk)
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/edit_risk", { risk_id: risk_id, risk: risk })
            .then(({ data }) => {
                dispatch({ type: "RISK", risk: data });
            });
    };
};

export const addIncident = (risk_id, incident) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/add_incident", { risk_id: risk_id, incident: incident });
    };
};



export const addAction = (risk_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/add_action", { risk_id: risk_id })
            .then(({ data }) => {
                //console.log("Data ", data)
                dispatch({ type: "RISK", risk: data });
            });
    };
};


export const addActionsFromFindings = (items) => {
    return async (dispatch) => {
        try {
            const { data } = await axios.post(API_URL + "/api/risk/bulk_from_findings", {
                items
            });

            ////console.log("Bulk create result:", data);

            // optional: refresh affected risks if backend doesn’t already return them
            // for example, loop over risk_ids and dispatch getRisk(risk_id)
            // or, if backend returns compact summaries, merge them however you like

            // dispatch({
            //     type: "BULK_ACTIONS_CREATED",
            //     payload: data.created,
            // });
        } catch (err) {
            console.error("Error bulk-creating actions:", err);
        }
    };
};


export const createActionFromFinding = (finding) => {
  return async (dispatch) => {
    try {
      const finding_id = finding?.finding_id ?? finding?.id;
      if (!finding_id) throw new Error("finding_id is required");

      const { data } = await axios.post(`${API_URL}/api/risk/action_from_finding`, {
        finding_id,
      });

      // data: { ok: true, action: {...}, finding: { finding_id, action_id } }
      if (!data?.ok || !data?.finding?.action_id) {
        throw new Error("failed to create action from finding");
      }

      // 1) Update the finding in any list you have (dept page, control page, etc.)
      // Example generic reducer event:
      

      return data; // let caller react (toast, navigate, etc.)
    } catch (err) {
      console.error("createActionFromFinding error:", err);
      throw err;
    }
  };
};

export const markFindingsComplete = (items) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.post(
        API_URL + "/api/risk/mark_findings_complete",
        { items }
      );

      ////console.log("Completed findings:", data);

    //   dispatch({
    //     type: "FINDINGS_MARKED_COMPLETE",
    //     payload: data.updated,
    //   });
    } catch (err) {
      console.error("Error marking findings complete:", err);
    }
  };
};

export const markFindingsOpen = (items) => {
  return async () => {
    try {
      // backend can accept either { items } or raw []
      await axios.post(API_URL + "/api/risk/mark_findings_open", { items });
      // no payload needed; you said you refetch after
    } catch (err) {
      console.error("Error reopening findings:", err);
    }
  };
};

export const addControl = (risk_id, owner_id) => {
    return (dispatch) => {
        return axios
            .post(API_URL + "/api/risk/add_control", { risk_id: risk_id, owner_id: owner_id })
            .then(({ data }) => {
                if (data.newControl) {
                    // Check if `newControl` exists in the response
                    ////console.log(data)
                    dispatch({ type: "RISK", risk: data.risk }); // Dispatch the updated risk data
                    ////////console.log("action newControl: ", data.newControl)
                    return data.newControl; // Return the newly added control
                } else {
                    throw new Error("API response does not include newControl");
                }
            })
            .catch((err) => {
                console.error("Error in addControl:", err);
                throw err; // Propagate error to the caller
            });
    };
};


export const addFinding = (control_id, type /* optional int */) => {
  return (dispatch) => {
    // only include `type` if it's provided (avoids sending undefined/null)
    const body = { control_id };
    if (type !== undefined && type !== null) body.type = type;

    return axios
      .post(`${API_URL}/api/risk/add_finding`, body)
      .then(({ data }) => {
        if (data?.success && data?.finding && Array.isArray(data?.findings)) {
          // data.findings now includes `type` as well
            ////console.log("data manual ", data)
          dispatch({
            type: "CONTROL_FINDINGS_REPLACE",
            payload: {
              control_id,
              findings: data.findings, // [{ id, type, title, finding_date, status }]
            },
          });

          // data.finding also includes `type` (+ risk_id, owners)
          return data.finding; 
        } else {
          throw new Error("API response missing finding or findings");
        }
      })
      .catch((err) => {
        console.error("Error in addFinding:", err);
        throw err;
      });
  };
};



export const addFindingAI = (control_id, aiResponse) => {
  return (dispatch) => {
    // only include `type` if it's provided (avoids sending undefined/null)
    ////console.log("aiResponse ", aiResponse)
    const body = { control_id, aiResponse };
    body.description = aiResponse.description
    body.impact = aiResponse.impact
    body.recommendation = aiResponse.recommendation
    body.root_cause = aiResponse.root_cause

    return axios
      .post(`${API_URL}/api/risk/add_finding_AI`, body)
      .then(({ data }) => {
        if (data?.success && data?.finding && Array.isArray(data?.findings)) {
          // data.findings now includes `type` as well
          ////console.log("data AI ", data)
        //   dispatch({
        //     type: "CONTROL_FINDINGS_REPLACE",
        //     payload: {
        //       control_id,
        //       findings: data.findings, // [{ id, type, title, finding_date, status }]
        //     },
        //   });

          // data.finding also includes `type` (+ risk_id, owners)
          return data.finding; 
        } else {
          throw new Error("API response missing finding or findings");
        }
      })
      .catch((err) => {
        console.error("Error in addFinding:", err);
        throw err;
      });
  };
};


export const addFindingsSurveyAIBatch = (aiFindings, survey_id) => {
  return (dispatch) => {
    const findings = (aiFindings || []).map((f) => ({
      title:
        f?.clause_code && f?.question_text
          ? `${f.clause_code} – ${String(f.question_text).slice(0, 90)}`
          : undefined,
      description: f.description,
      impact: f.impact,
      recommendation: f.recommendation,
      root_cause: f.root_cause,
      survey_id: survey_id
    }));

    // remove undefined titles
    findings.forEach((x) => x.title === undefined && delete x.title);

    return axios
      .post(`${API_URL}/api/risk/add_finding_survey_AI`, { findings })
      .then(({ data }) => {
        if (data?.success) {
          return data;
        }
        throw new Error("Batch insert failed");
      })
      .catch((err) => {
        console.error("Error in addFindingsSurveyAIBatch:", err?.response?.data || err);
        throw err;
      });
  };
};





export const addComment = (comment, risk_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/risk/add_comment", { comment: comment, risk_id: risk_id })
            .then(({ data }) => {
                //dispatch({ type: "ADD_COMMENT", comment: data.comment });
                dispatch({ type: "RISK", risk: data });
            });
    };
};

export const openOverlay = (id) => {
    return (dispatch) => {
        dispatch({ type: "OPEN_OVERLAY", id: id });
    };
};

export const closeOverlay = () => {
    //////console.log("Closed")
    return (dispatch) => {
        dispatch({ type: "CLOSE_OVERLAY" });
    };
};

export const closeControl = () => {
    ////console.log("Closed")
    return (dispatch) => {
        dispatch({ type: "CLOSE_CONTROL" });
    };
};



// export const getRisk = (id) => {
//     //////console.log('getRisk - Fetching risk with ID:', id);
//     return (dispatch) => {
//         axios.get(API_URL + "/api/risk/get_risk/" + id)
//             .then(({ data }) => {
//                 //////console.log('getRisk - Received data:', data);
//                 dispatch({ type: "RISK", risk: data });
//             })
//             .catch(error => {
//                 console.error('getRisk - Error fetching risk:', error);
//             });
//     };
// };

export const getRisk = (id) => {
    const riskId = Number(id);
    if (!Number.isFinite(riskId) || riskId <= 0) {
        return () => {};
    }

    return (dispatch) => {
        axios.get(API_URL + "/api/risk/get_risk/" + riskId)
            .then(({ data }) => {
                //console.log("Getting risk ", data)
                dispatch({ type: "RISK", risk: data });
            })
            .catch((error) => {
                console.error("getRisk - Error fetching risk:", error);
            });
    };
};


export const ALL_RISKS_DEPARTMENT_SCOPE = "all";

let _risksRequestSeq = 0;

export const getRisks = (currentPage, pageSize, department_id, sortBy) => {

    let sortByString = sortBy ? sortBy?.length > 0 ? JSON.stringify(sortBy[0]) : null : null;
    const scopeId =
        department_id === ALL_RISKS_DEPARTMENT_SCOPE || department_id == null
            ? ALL_RISKS_DEPARTMENT_SCOPE
            : department_id;
    const apiDeptParam = scopeId === ALL_RISKS_DEPARTMENT_SCOPE ? "null" : scopeId;

    return (dispatch) => {
        const seq = ++_risksRequestSeq;
        dispatch({ type: "RISKS_REQUEST", department_id: scopeId });
        axios.get(API_URL + "/api/risk/get_risks?currentPage=" + currentPage + "&pageSize=" + pageSize + "&department_id=" + apiDeptParam + "&sortBy=" + sortByString, { timeout: 15000 })
            .then(({ data }) => {
                if (seq !== _risksRequestSeq) {
                    // Stale response — a newer request is in flight; just clear loading
                    dispatch({ type: "RISKS_FETCH_FAILED" });
                    return;
                }
                dispatch({
                    type: "RISKS",
                    risks: data.risks,
                    totalPages: data.totalPages,
                    department_id: scopeId,
                });
            })
            .catch(() => {
                if (seq === _risksRequestSeq) {
                    dispatch({ type: "RISKS_FETCH_FAILED" });
                }
            });
    };
};


export const fetchRiskAssets = (risk_id) => {
    return async () => {
        try {
            const { data } = await axios.get(`${API_URL}/api/risk/risk_assets/${risk_id}`);
            return data;
        } catch (err) {
            console.error("Error fetching risk assets:", err);
            return [];
        }
    };
};

export const updateRiskAssets = (risk_id, asset_ids) => {
    return async () => {
        try {
            const { data } = await axios.post(`${API_URL}/api/risk/update_risk_assets`, { risk_id, asset_ids });
            return data;
        } catch (err) {
            console.error("Error updating risk assets:", err);
            return [];
        }
    };
};

export const getDepartmentThreatsForAI = (department_id) => {
    return async () => {
        try {
            const { data } = await axios.get(
                `${API_URL}/api/risk/get_department_threats?department_id=${department_id}`
            );
            return data;
        } catch (err) {
            console.error("Error fetching department threats:", err);
            return [];
        }
    };
};

export const resetError = () => {
    return (dispatch) => {
        dispatch({ type: "RESET_ERROR" });
    };
};

export const resetNewlycreatedRiskId = () => {
    return (dispatch) => {
        dispatch({ type: "RESET_NEWLYCREATED_RISK_ID" });
    };
};

export const createRisk = (currentPage, pageSize, department_id, sortBy) => {
    let sortByString = sortBy ? sortBy?.length > 0 ? JSON.stringify(sortBy[0]) : null : null;

    return (dispatch) => {
        dispatch({ type: "RESET_ERROR" });

        return axios.post(API_URL + "/api/risk/create_risk", { 
            currentPage: currentPage, 
            pageSize: pageSize, 
            department_id: department_id,  
            compliance_id: null, 
            sortBy: sortByString, 
            risk_type: "Department"
        })
        .then(({ data }) => {
            //////console.log('Risk created:', data);
            
            // First dispatch OPEN_OVERLAY to ensure the overlay is open
            if (data.newlycreatedRiskId) {
                dispatch({ type: "OPEN_OVERLAY", id: data.newlycreatedRiskId });
            }
            
            // Then dispatch the RISKS action to update the list
            dispatch({
                type: "RISKS",
                risks: data.risks,
                totalPages: data.totalPages,
                department_id: department_id,
                newlycreatedRiskId: data.newlycreatedRiskId
            });
            
            // Finally fetch and dispatch the newly created risk details
            if (data.newlycreatedRiskId) {
                return axios.get(API_URL + "/api/risk/get_risk/" + data.newlycreatedRiskId)
                    .then(({ data: riskData }) => {
                        //////console.log('Fetched new risk details:', riskData);
                        // Ensure the risk object has the same structure as when editing
                        const completeRiskData = {
                            ...riskData,
                            risk: {
                                ...riskData.risk,
                                ID: data.newlycreatedRiskId,
                                Status: 'In Review',
                                DepartmentID: department_id,
                                controls: [],
                                actions: [],
                                comments: [],
                                departments: riskData.departments || [],
                                users: riskData.users || []
                            }
                        };
                        dispatch({ type: "RISK", risk: completeRiskData });
                        return completeRiskData;
                    });
            }
        })
        .catch((error) => {
            console.error('Error in createRisk:', error);
            dispatch({ type: "ERROR_CREATING_RISK", error: error.message });
            throw error;
        });
    };
};

export const createComplianceRisk = (currentPage, pageSize, compliance_id, sortBy) => {
    let sortByString = sortBy ? (sortBy?.length > 0 ? JSON.stringify(sortBy[0]) : null) : null;

    return (dispatch) => {
        dispatch({ type: "RESET_ERROR" });

        axios
            .post(API_URL + "/api/risk/create_risk", {
                currentPage: currentPage,
                pageSize: pageSize,
                department_id: null,
                compliance_id: compliance_id,
                sortBy: sortByString,
                risk_type: "Compliance", // Set the risk_type to Compliance
     
            })
            .then(({ data }) => {
                //////console.log(data);

                if (data.newlycreatedRiskId) {
                dispatch({ type: "OPEN_OVERLAY", id: data.newlycreatedRiskId });
            }

                dispatch({
                    type: "COMPLIANCE_RISKS",
                    complianceRisks: data.risks,
                    totalPages: data.totalPages,
                    scopeKey: `comp:${compliance_id ?? 0}`,
                    newlyCreatedComplianceRiskId: data.newlycreatedRiskId,
                });
            })
            .catch((error) => {
                ////////console.log(error);
                dispatch({ type: "ERROR_CREATING_RISK" });
            });
    };
};


export const getDepartments = () => {
    return (dispatch) => {
        axios.get(API_URL + "/api/department/get_departments")
            .then(({ data }) => {
                dispatch({ type: "DEPARTMENTS", departments: data });
            });
    };
};

export const editActionProgress = (action_id, real_progress) => {
    return (dispatch) => {
        // Validate the input
        if (!action_id || real_progress === undefined || real_progress < 0 || real_progress > 100) {
            console.error("Invalid input. 'action_id' and 'real_progress' are required, and real_progress must be between 0 and 100.");
            return Promise.reject(new Error("Invalid input."));
        }

        // Make the API request
        return axios
            .post(API_URL + "/api/risk/edit_action_progress", {
                action_id: action_id,
                real_progress: real_progress,
            })
            .then(({ data }) => {
                if (data.success) {
                    // Dispatch updated action details to the store
                    dispatch({
                        type: "ACTION_DETAILS",
                        action_details: data.action,
                    });

                    ////////console.log("Action progress updated successfully.");
                    return data.action; // Return updated action details for further usage
                } else {
                    console.error("Failed to update action progress:", data.message);
                    throw new Error(data.message || "Unexpected error while updating progress.");
                }
            })
            .catch((error) => {
                console.error("Error in editActionProgress:", error);
                throw error; // Propagate error to the caller
            });
    };
};

export const getComplianceRisks = (currentPage, pageSize, complianceStandardId, sortBy) => {
    const sortByString = sortBy ? (sortBy?.length > 0 ? JSON.stringify(sortBy[0]) : null) : null;
    const scopeKey = `comp:${complianceStandardId ?? 0}`;

    return (dispatch) => {
        dispatch({ type: "COMPLIANCE_RISKS_REQUEST", compliance_id: complianceStandardId });
        axios.get(`${API_URL}/api/risk/get_compliance_risks`, {
            params: {
                currentPage,
                pageSize,
                compliance_id: complianceStandardId,
                sortBy: sortByString,
            },
        })
        .then(({ data }) => {
            dispatch({
                type: "COMPLIANCE_RISKS",
                complianceRisks: data.risks,
                totalPages: data.totalPages,
                scopeKey,
            });
        })
        .catch((error) => {
            console.error("Error fetching compliance risks:", error);
            dispatch({ type: "COMPLIANCE_RISKS_LOADED" });
            dispatch({ type: "ERROR_FETCHING_COMPLIANCE_RISKS" });
        });
    };
};

// Action to reset error for compliance risks
export const resetComplianceError = () => {
    return { type: "RESET_ERROR_COMPLIANCE" };
};

// Action to open overlay for compliance risks
export const openComplianceOverlay = () => {
    return { type: "OPEN_COMPLIANCE_OVERLAY" };
};

// Action to close overlay for compliance risks
export const closeComplianceOverlay = () => {
    return { type: "CLOSE_COMPLIANCE_OVERLAY" };
};

// Action to reset newly created compliance risk ID
export const resetNewlyCreatedComplianceRiskId = () => {
    return (dispatch) => {
        dispatch({ type: "RESET_NEWLYCREATED_COMPLIANCE_ID" });
    };
};

// Action to set the current page for compliance risks
export const setComplianceCurrentPageRedux = (page) => {
    return { type: "SET_COMPLIANCE_CURRENT_PAGE", page };
};

// Action to reset changed page size for compliance risks
export const resetComplianceChangedPageSize = () => {
    return { type: "RESET_CHANGED_PAGE_SIZE_COMPLIANCE" };
};

// Action to set page size for compliance risks
export const setCompliancePageSizeRedux = (size) => {
    return { type: "SET_PAGE_SIZE_COMPLIANCE", size };
};
